/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Chat_Timeline_First_OutputInputs */



/**
* | output |
* | --- |
* | "first output after {duration}" |
*
* @param {Chat_Timeline_First_OutputInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_timeline_first_output = /** @type {((inputs: Chat_Timeline_First_OutputInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Timeline_First_OutputInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`erste Ausgabe nach ${i?.duration}`)
	return /** @type {LocalizedString} */ (`first output after ${i?.duration}`)
});